import { account } from '@dooray/api-client';
import { CustomSettingStore } from '@dooray/repository-store';

import { LOCALE_CODE } from '~/constants';
import { globalSettingStore } from '~/stores/GlobalSettingStore';

export const getHelpUrl = ({
  helpUrl,
  locale,
  pageId,
}: {
  helpUrl: string;
  locale: LOCALE_CODE | null;
  pageId?: account.HELP_PAGE_ID;
}): string | null =>
  globalSettingStore.isInitializedCustomSetting
    ? CustomSettingStore.getInstance().getHelpUrl({ helpUrl, locale, pageId })
    : null;
